import DataInputs from 'react-scale/components/pages/rapid/data-inputs';
import Pricing from 'react-scale/components/pages/rapid/pricing';
import GalleryCountdown from 'react-scale/components/pages/rapid/gallery-countdown';

export {
  DataInputs,
  Pricing,
  GalleryCountdown
};
